import { useMemo } from "react";
import TimezoneSelectView from "./TimezoneSelectView";

function TimezoneSelect({
  value,
  onChange,
  disabled,
  nullable = false,
  placeholder,
}) {
  /**
   * Determine the options for this select (all IANA timezones known to the browser)
   */
  const options = useMemo(() => {
    const timezones = Intl.supportedValuesOf
      ? Intl.supportedValuesOf("timeZone")
      : [Intl.DateTimeFormat().resolvedOptions().timeZone];

    //Make sure the current value is always selectable
    if (value && !timezones.includes(value)) {
      timezones.push(value);
    }

    return timezones.map((timezone) => ({
      value: timezone,
      label: timezone.replaceAll("_", " "),
    }));
  }, [value]);

  return (
    <TimezoneSelectView
      options={options}
      value={value}
      onChange={onChange}
      disabled={disabled}
      nullable={nullable}
      placeholder={placeholder}
    />
  );
}

export default TimezoneSelect;
